import React from "react";

export default function Tag(props: { value: string }): React.ReactNode {
  return (
    <div className="px-2 py-1 rounded-lg bg-lightGray text-xs">
      {props.value}
    </div>
  );
}
